import SpriteSymbol from "../../../../../../../shared/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../config/webpack/loaders/svg-sprite/utils/sprite";
var symbol = new SpriteSymbol({
  "id": "icon__close",
  "use": "icon__close-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon__close\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m11 11.707-7.646 7.647-.708-.707L10.293 11 2.647 3.354l.707-.708L11 10.293l7.646-7.647.708.708L11.707 11l7.647 7.646-.707.708L11 11.707Z\" fill=\"#000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol